import {Injectable} from '@angular/core';
import {BaseService} from '@core/service/base.service';
import {UrlConstant} from '@shared/constants/url.constant';

@Injectable({providedIn: 'root'})
export class NotiHistoryService extends BaseService {
  getHistory(params: { pageNumber: number; pageSize: number; fromDate?: string; toDate?: string; isSent?: number }) {
    return this.post(UrlConstant.NOTIFICATION.PREFIX + UrlConstant.NOTIFICATION.GET_HISTORY, params);
  }
}
